import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { setShowServerErrorMessage } from "./errorManagementSlice";
import errorStatusProvider from "../utils/errorStatusProvider";

const initialState = {
  page_content: null,
  loading: true,
  error: null,
};

const baseUrl = process.env.REACT_APP_API;

export const fetchThankYou = createAsyncThunk(
  "thankYou/fetchThankYou",
  async (country) => {
    return fetch(
      `${baseUrl}/api/registration-form-page/6/${
        country.countryCode
      }/?file_warning=${country.warningFile ? "true" : "false"}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Accept-Language":
            country.language === "en" ? "en-UK" : country.language,
        },
      }
    ).then((res) => errorStatusProvider(res));
  }
);

export const getThankYou =
  (countryCode, language, warningFile) => async (dispatch) => {
    const result = await dispatch(
      fetchThankYou({ countryCode, language, warningFile })
    );

    const { data, responseStatus } = result.payload;

    dispatch(setShowServerErrorMessage(responseStatus));

    return data;
  };

export const thankYouSlice = createSlice({
  name: "ThankYouScreen",
  initialState,
  reducers: {
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchThankYou.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchThankYou.fulfilled, (state, action) => {
        state.loading = false;
        state.page_content = action.payload?.data?.page_content;
      })
      .addCase(fetchThankYou.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error;
      });
  },
});

export const { setError } = thankYouSlice.actions;

export default thankYouSlice.reducer;
